import React from 'react'
import im from "./home_anime.f372ef86.gif";

import "./projects.css";

import dict from "./clipart-definition-manual.webp";
import text from "./TEXt convertor.webp";
import country from "./country.png";
import news from "./news.png";
import weath from "./Weather-icon.webp";
import wwe from "./wwe.webp";

import name from "./Nameit.webp";


import phama from "./nutrition.jpg";


import pokemon from "./pokem-removebg-preview.png";

import calender from "./calender.png";
import allinone from "./allinone.png";
import calculator from "./calculator.jpg";

import Typewriter from "typewriter-effect";

import note from "./note.png";




export default function Projects() {

let a=[
{

	id:1,
	img:dict,
	name:"Dictionary",
	click:"Explore",
	body:"A dictionary entry is a set of information that describes a word or phrase.",
	url:"https://atanurag.github.io/Dict/"

},

{


	id:2,
	img:phama,
	name:"Get Nutrition Value",
	body:"Nutrition is the biochemical and physiological process by which an organism uses food to support its life.",
	click:"Explore",
	url:"https://atanurag.github.io/get-nutrition-value/"
}

,

{


	id:3,
	img:weath,
	name:"Check Weather",
	body:"It is the state of the atmosphere, describing for example the degree to which it is hot or cold, wet or dry etc.",
	click:"Explore",
	url:"https://atanurag.github.io/weather/"
}

 
,


{


	id:4,
	img:country,
	name:"Country Details",
	body:"Get to know about Coat Of Arms,Continent,Capital etc.",
	click:"Explore",
	url:"https://atanurag.github.io/Country/"
}


,

{


	id:4,
	img:news,
	name:"Live News",
	body:"Track live news here.",
	click:"Explore",
	url:"https://atanurag.github.io/news/"
}

,

{


	id:5,
   img:calender,
	name:"Calender",
	body:"A printed table showing the arrangement of the days, weeks, and months of the year. ",
	click:"Explore",
	url:"https://atanurag.github.io/caln/"
}
,



{


	id:5,
   img:allinone,
	name:"Projets Bundle",
	body:"Checkout my all updated and new projects here. ",
	click:"Explore",
	url:"https://atanurag.github.io/projects-re/"
}
,

{


	id:10,
   img:note,
	name:"Note App",
	body:"Write your sticky notes. ",
	click:"Explore",
	url:" https://atanurag.github.io/note/"
}

,

{

	id:6,
	img:wwe,
	name:"Wwe-superstars",
	body:"Check name,place,weight and championship-Reigns of wwe superstars. ",
    click:"Explore",
	url:"https://atanurag.github.io/-wwe/"
}

 ,

{


	id:7,
	img:pokemon,
	name:"Pokemon",
	body:"Checkout your favorite pokemon details. ",
	click:"Explore",
	url:"https://atanurag.github.io/pokemon-1/"
}
 
,{

id:8,
	img:calculator,
	name:"Age calculator",
	body:"Find your age.  ",
	
	click:"Explore",
	url:"https://atanurag.github.io/ageC/"

 
}
 , 


{


	id:4,
	img:text,
	name:"TEXt convertor",
	body:"A translator to convert normal text to fancy text.",
	click:"Explore",
	url:"https://atanurag.github.io/text/"
}
,

 {

id:9,
	img:name,
	name:"Name It", 
	click:"Explore",
body:"What does your name say about your personality",
	url:"https://atanurag.github.io/imgapi/"

 
}





]

	return (
		<div>




		<div className="mar">

		

<h1 className="text-center font-bold hh">My Projects.</h1>



<h3 className="text-center hh1 " style={{marginTop:"33px"}}>

<Typewriter
  

options={{
    delay: 75,
    autoStart: true,
    
  }}


       onInit={(typewriter)=> {

       typewriter
        
       .typeString("Here are the few cool things i've worked on.")
         

  


       .start();
       }}
       /> 


</h3>
	

</div>

<div className="d-flex justify-content-between flex-wrap " style={{padding:"0px 82px 99px 93px"}}>

{a.map((user) => (
<>
       <div className="card text-center mx-auto  k">
        <img className=" card-img " src={user.img} key={user.id} alt="Card image cap" />
        <div className="card-body j">
          <h5 className="card-title">{user.name}</h5>
          <p className="card-text">{user.body}</p>
          <a href={user.url} className="btn btn-primary bt">{user.click}</a>
        </div>
      </div>

</>
      ))}
</div>












</div>


		
	)
}